$(document).ready(function () {
  $('.yumtein__blog-details-inner-content .glide').each(function () {
    const $glide = $(this);
    const slidesPerView = $glide.data('slides-per-view') || 3;

    const glideInstance = new Glide($glide[0], {
      type: 'slider',
      perView: slidesPerView,
      gap: 20,
      rewind: false,
      bound: true,
      breakpoints: {
        600: {
          perView: 2,
          gap: 10,
        },
        480: {
          perView: 1,
        },
      },
    });

    const $prevArrow = $glide.find('.glide__arrow--left');
    const $nextArrow = $glide.find('.glide__arrow--right');

    function getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 600) return 2;
      return $glide.data('slides-per-view') || 3;
    }

    function updateArrows() {
      const slidesPerView = getSlidesPerView();
      const index = glideInstance.index;
      const totalSlides = $glide.find('.glide__slide:not(.glide__slide--clone)').length;
      const maxIndex = totalSlides - slidesPerView;

      if (index <= 0) {
        $prevArrow.addClass('disabled');
      } else {
        $prevArrow.removeClass('disabled');
      }

      if (index >= maxIndex) {
        $nextArrow.addClass('disabled');
      } else {
        $nextArrow.removeClass('disabled');
      }
    }

    glideInstance.on(['mount.after', 'run.after'], updateArrows);

    glideInstance.mount();

    window.dispatchEvent(new Event('resize'));

    const $originalLinks = $(this).find('.blog__slide:not(.glide__slide--clone) .popup-link');

    $originalLinks.magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
      },
      mainClass: 'mfp-fade',
      removalDelay: 300,
    });
  });

  $('.yumtein__blog-details-inner-content p').each(function () {
    if ($(this).html().trim() === '&nbsp;' || $(this).html().trim() === '') {
      $(this).addClass('empty-paragraph');
    }
  });

  var chevronSvg =
    '<svg class="closed" width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="1.0957" y="1.19287" width="28" height="28" rx="6" fill="white"/>' +
      '<rect x="1.0957" y="1.19287" width="28" height="28" rx="6" stroke="#001C3D" stroke-width="2"/>' +
      '<path d="M10.0977 13.05L14.7405 17.6929L19.3834 13.05" stroke="#001C3D" stroke-width="4.28571" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  $('.blog-accordion').each(function () {
    $(this).children(':header').each(function () {
      var $heading = $(this);
      var title = $heading.text();
      var $content = $heading.next();

      if (!$content.length || $content.is(':header')) return;

      var $item = $('<div class="accordion-item"><p>' + title + chevronSvg + '</p></div>');
      $heading.before($item);
      $content.addClass('accordion-item-content');
      $item.append($content);
      $heading.remove();
    });
  });
});
